<template>
  <div>
    <v-label>{{label}}</v-label>
    <div>
      <v-btn flat
             icon
             :disabled="!decreaseAllowed"
             color="primary"
             @click="handleDecreaseClick">
        <v-icon small>remove_circle</v-icon>
      </v-btn>
      <b>{{newValue}}</b>
      <v-btn flat
             icon
             :disabled="!increaseAllowed"
             color="primary"
             @click="handleIncreaseClick">
        <v-icon small>add_circle</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'number-delta-input',
        props: {
            currentValue: {
                type: Number,
                required: true
            },
            value: {
                type: Number,
            },
            minValue: {
                type: Number,
                default: 1
            },
            maxValue: {
                type: Number,
                required: true
            },
            label: String
        },
        data() {
            return {}
        },
        computed: {
            newValue() {
                return this.currentValue + this.value
            },
            decreaseAllowed() {
                return this.newValue - 1 >= this.minValue
            },
            increaseAllowed() {
                return this.newValue + 1 <= this.maxValue
            }
        },
        methods: {
            handleDecreaseClick() {
                this.$emit('input', this.value - 1)
            },
            handleIncreaseClick() {
                this.$emit('input', this.value + 1)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/NumberDeltaInput.vue